var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { GeminiActionBreakdown } from '@web/components/Apps/Gemini/GeminiActionBreakdown';
import { GeminiAdoptionTrend } from '@web/components/Apps/Gemini/GeminiAdoptionTrend';
import GeminiSummary from '@web/components/Apps/Gemini/GeminiSummary';
import { GeminiUsageCategoryByApp } from '@web/components/Apps/Gemini/GeminiUsageCategoryByApp';
import { GeminiUsageLevelDistribution } from '@web/components/Apps/Gemini/GeminiUsageLevelDistribution';
import StickyFilters from '@web/components/Filters/StickyFilters';
import { PowerAiUsers } from '@web/components/PerformanceReview/Employee/Sections/AIAdoption&Usage/PowerAiUsers';
export var GeminiTab = function () { return (_jsxs(_Fragment, { children: [_jsx(StickyFilters, {}), _jsxs("div", __assign({ className: "flex flex-col mx-1 gap-20 mt-5" }, { children: [_jsx(GeminiSummary, {}), _jsx(GeminiUsageLevelDistribution, {}), _jsx(GeminiUsageCategoryByApp, {}), _jsx(GeminiActionBreakdown, {}), _jsx(GeminiAdoptionTrend, {}), _jsx(PowerAiUsers, {})] }))] })); };
